"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Help;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Screen_1 = __importDefault(require("../components/Screen"));
const HelpContactSection_1 = __importDefault(require("../partials/HelpContactSection"));
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const react_i18next_1 = require("react-i18next");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const react_native_device_info_1 = __importDefault(require("react-native-device-info"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        text: {
            color: THEME.Text,
            fontSize: size != 'sm' ? 20 : 16,
            textAlign: 'center',
            alignSelf: 'center',
            paddingHorizontal: 8,
            paddingTop: 8,
            fontWeight: '300'
        },
        subtext: {
            color: THEME.Text,
            fontSize: size != 'sm' ? 16 : 12,
            textAlign: 'center',
            alignSelf: 'center',
            paddingHorizontal: 8,
            paddingBottom: 8,
            opacity: 0.7,
            fontWeight: '300'
        }
    });
};
function Help(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [refreshKey, setRefreshKey] = react_1.default.useState(0);
    // Randomly update the key used in the MasonryList below. This will force the list to re-render
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshKey(Math.random());
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Screen_1.default, { onRefresh: onRefresh, cardAdjust: false, containerStyle: { backgroundColor: size != 'sm' && !react_native_device_info_1.default.isTablet() ? undefined : THEME.SoftGray }, scrollStyle: { paddingTop: 3, backgroundColor: size != 'sm' && !react_native_device_info_1.default.isTablet() ? undefined : THEME.SoftGray }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                    marginHorizontal: size != 'sm' ? 16 : 12,
                    marginTop: (size != 'sm' ? 6 : 8),
                    marginBottom: (size != 'sm' ? 12 : 8),
                    borderRadius: 4
                }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { maxHeight: 300 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { resizeMode: 'cover', source: size != 'sm' ? Theme_1.IMAGES.HelpBackgroundWeb : Theme_1.IMAGES.HelpBackground, style: { width: '100%', height: 'auto', aspectRatio: size != 'sm' ? 11.2 : 5.6, borderTopLeftRadius: 4, borderTopRightRadius: 4 } }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { backgroundColor: THEME.LavenderGray, borderBottomLeftRadius: 4, borderBottomRightRadius: 4, marginTop: -1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.text, children: t('help:text.contact') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.subtext, children: t('help:text.expertsOn') })] })] }), (0, jsx_runtime_1.jsx)(HelpContactSection_1.default, { navigation: props.navigation })] }));
}
